<div class="container-fluid">
    <div  style="display: inline;block-size: 10%;">
    <!--Header-->
      <div class="col-md-12 col-12 col-sm-12 pad0 bgWhite" style="padding-left: 0px; padding: 15px;">
         <div class="col-md-4 col-sm-6 lblHeader newHeader" style="display: inline-block;padding: 0px;">
            <h2 style="font-size: 25px;">Non Moving Stock</h2>
        </div>
        <div class="col-md-8 col-sm-6" style="display: inline-block; padding: 0px;text-align: right;">
          <span  *ngIf="dataSource.data.length > 0" class="search" >
          <span class="fa fa-search"></span>
          <input class="form-control brdrColor brdrRadius3" ng-model="search.term" placeholder="Search" matInput
            (keyup)="applyFilter($event)" #input
            style="text-align: left;display: inline-block; padding-left: 35px !important; font-size: 13px; box-shadow: none; width: 30% !important; height: 33px !important;"
            type="text">
          </span>
          <span *ngIf="exportToExcel.length > 0" (click)="exportToExcelActivities();" class="btn btn-orange brdrRadius3" style="margin-left: 10px; cursor: pointer;line-height: 22px; padding: 4px 10px;" title="Export to Excel">
            <span><i aria-hidden="true" style="font-size: 14px;" class="fa fa-file-excel-o"></i></span>
          </span>
          <div style="display: inline-block; padding: 0px;" title="Back to Account Dashboard">
            <span class="btn-darkBlue brdrRadius3"
                style="font-size: 13px; display: inline-block; padding: 4px 12px 5px; margin-left: 10px;"
                (click)="backBtn()">
                <i class="fa fa-chevron-left" style="margin-right: 3px;"></i> Return to Inventory
            </span>
        </div>
      </div>
    </div>
  </div>

    <!--Filter-->
    <div class="col-md-12 col-xs-12 col-sm-12" style="margin-bottom: 25px;display: inline-block;">
      <div style="display: inline-block">
        <!-- Category-->
        <div style="display: inline-block;">
          <span style="vertical-align: middle; margin-right: 8px; font-size: 13px;">Category :</span>
        </div>
        <div style="display: inline-block; margin-right: 20px; cursor: pointer;">
          <select class="form-control bgwhite formCtlFltr" style="box-shadow: none;width: 170px; cursor: pointer;"
            [(ngModel)]="filter.cateID" (change)="changeCategory()">
            <option value="0"> Select Category </option>
            <option *ngFor="let c of ItemCategories" value="{{c.cid}}">{{c.cnm}}</option>
          </select>
        </div>
        <!--sub category-->
        <div *ngIf="filter.cateID != 0" style="display: inline-block; margin-right: 20px; cursor: pointer;">
          <select class="form-control bgwhite formCtlFltr" style="box-shadow: none;width: 170px; cursor: pointer;"
            [(ngModel)]="filter.subCateID" (change)="changeFilterApply()">
            <option value="0"> Select Sub-category </option>
            <option *ngFor="let s of subCategoryList" value="{{s.sid}}">{{s.snm}}</option>
          </select>
        </div>
      </div>  
        <!--Priority:-->
        <div style="display: inline-block;">
          <span style="vertical-align: middle; margin-right: 8px; font-size: 13px;">Priority :</span>
          </div>
          <div style="display: inline-block; margin-right: 20px; cursor: pointer;">
            <select class="form-control bgwhite formCtlFltr" style="box-shadow: none;width: 170px; cursor: pointer;"
              [(ngModel)]="filter.priorityTypeID" (change)="changeFilterApply()">
              <option value="-1"> Select Priority </option>
              <option *ngFor="let i of itemImportant" value="{{i.id}}">{{i.itemType}}</option>
            </select>
          </div>

        <!--Last Used:-->
        <div style="display: inline-block;">
          <span style="vertical-align: middle; margin-right: 8px; font-size: 13px;">Last Used :</span>
        </div>
        <div style="display: inline-block; margin-left: -15px; cursor: pointer;">
          <div  class="col-md-12 col-xs-12 col-12" style="margin-top: 10px; display: inline-block;">
            <input type="text" class="form-control" [(ngModel)]="filter.lastUsedDays" (blur)="changeFilterApply()" maxlength="10"  style="text-indent: 2px; width: 65px; background: none !important;" placeholder="" captalize-first>
        </div>
        </div>
        <span style="vertical-align: middle; font-size: 13px; margin-left: -13px;">days ago</span>
      </div>  
      <!--Data Table-->
      <div *ngIf="dataSource.data.length > 0" #mtlAviaTable class="col-md-12 col-12 col-sm-12" style="text-overflow: ellipsis; white-space: nowrap;">
        <div class="col-md-12 col-12 col-sm-12 pad0 bzMatTbl shadow brdrRadius3" style="padding: 0px !important;">
          <table mat-table [dataSource]="dataSource" matSort class="brdrRadius3">
            <ng-container matColumnDef="ItemName" style="cursor: pointer;">
              <th class="header header-Table" mat-header-cell *matHeaderCellDef mat-sort-header>
                  <label>Item</label>
              </th>
              <td mat-cell *matCellDef="let element" style="width: 20% !important;"> {{element.ItemName ? element.ItemName :  '-'}} </td>
            </ng-container>
            <ng-container matColumnDef="categoryName">
              <th class="header header-Table" style="cursor: pointer; padding-left: 3% !important;" mat-header-cell *matHeaderCellDef mat-sort-header>
                  <label>Category</label>
              </th>
              <td mat-cell *matCellDef="let element" style="padding-left: 45px !important; width: 15% !important;"> {{element.categoryName ? element.categoryName : '-'}} </td>
            </ng-container>
            <ng-container matColumnDef="subCategoryName">
              <th class="header header-Table" style="cursor: pointer; padding-left: 3% !important;" mat-header-cell *matHeaderCellDef mat-sort-header>
                <label>Sub Category</label>
              </th>
              <td mat-cell *matCellDef="let element" style="padding-left: 45px !important; width: 15% !important;"> {{element.subCategoryName ? element.subCategoryName : '-'}} </td>
            </ng-container>
            <ng-container matColumnDef="priority">
              <th class="header header-Table" style="cursor: pointer; padding-left: 3% !important;" mat-header-cell *matHeaderCellDef mat-sort-header>
                <label>Priority</label>
              </th>
              <td mat-cell *matCellDef="let element" style="padding-left: 40px !important; width: 10% !important;"> {{element.priority ? element.priority : '-'}} </td>
            </ng-container>
            <ng-container matColumnDef="MinLevel">
              <th class="header header-Table" style="cursor: pointer; padding-left: 3% !important;" mat-header-cell *matHeaderCellDef mat-sort-header>
                <label>Min Level</label>
              </th>
              <td mat-cell *matCellDef="let element" style="text-align:right; padding-right: 30px !important; width: 10% !important;"> {{element.MinLevel ? element.MinLevel : '-'}} </td>
            </ng-container>
            <ng-container matColumnDef="StockQty">
              <th class="header header-Table" style="padding-left: 2% !important;cursor: pointer;" mat-header-cell *matHeaderCellDef mat-sort-header>
                <label> StockQty </label>
              </th>
              <td mat-cell *matCellDef="let element" style="width: 10% !important; text-align: right; padding-right: 40px !important;"> {{element.StockQty ? element.StockQty : '-'}}  {{element.StockQty ? element.Unit : ''}} </td>
            </ng-container>
            <ng-container matColumnDef="ValueRate">
              <th class="header header-Table" style="cursor: pointer;" mat-header-cell *matHeaderCellDef mat-sort-header>
                <label> Value (Rs.) </label>
              </th>
              <td mat-cell *matCellDef="let element" style="width: 10% !important; text-align: right; padding-right: 60px !important;"> {{element.ValueRate ? (element.ValueRate | lacFormat : 1): '-'}} </td>
            </ng-container>
            <ng-container matColumnDef="LastUsedDT">
              <th class="header header-Table" style="cursor: pointer;" mat-header-cell *matHeaderCellDef mat-sort-header>
                <label> Last Used </label>
              </th>
              <td mat-cell *matCellDef="let element" style="width: 10% !important;"> {{element.LastUsedDT ? (element.LastUsedDT | date: 'dd-MMM-yy') : '-'}} </td>
            </ng-container>
            <ng-container matColumnDef="days">
              <th class="header header-Table" style="cursor: pointer;" mat-header-cell *matHeaderCellDef mat-sort-header>
                <label> Unused for </label>
              </th>
              <td mat-cell *matCellDef="let element" style="width: 10% !important;"> {{element.days ? element.days : '-'}} {{element.days ? (element.days > 1 ? ' Days' : ' Day') : ''}} </td>
            </ng-container>
            <ng-container matColumnDef="LeadTime">
              <th class="header header-Table" style="cursor: pointer;" mat-header-cell *matHeaderCellDef mat-sort-header>
                <label>Lead Time</label>
              </th>
              <td mat-cell *matCellDef="let element" style="width: 10% !important;"> {{element.LeadTime ? element.LeadTime : '-'}} {{element.LeadTime != 0 ?(element.LeadTime > 1 ? 'Days' : 'day') : ''}} </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; let i = index; columns: displayedColumns;"></tr>
        </table>
          <!-- Angular 8 pagination -->
          <mat-paginator [pageSizeOptions]="[10,20,30,40,50]" showFirstLastButtons class="brdrRadius3">
          </mat-paginator>
        </div>
      </div>
    <div *ngIf="nonMovingStockList.length == 0">
      <div style="margin:15px" class="nrf brdrRadius3">No records found.</div>
    </div>
  </div>
<ngx-spinner color="rgb(232, 132, 33)" size="default" type="ball-clip-rotate">
</ngx-spinner>